import TextAndImage from './TextEntryDisplay';

export default TextAndImage;
